import React, { useEffect, useContext, useState, useRef } from 'react';

import { AuthContext } from '../../contexts/auth.context';
import firebase from '../../firebase/base';

import {
  UserContainer,
  UserThumbnail,
  DropdownContainer,
  SignOut
} from './UserAndActions.styles';

const UserAndActions = ({ className }) => {
  const [isOpen, setIsOpen] = useState(false);
  const activatorRef = useRef();
  const listRef = useRef();

  const { userProfile } = useContext(AuthContext);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  const handleSignOut = () => {
    firebase.auth().signOut();
    setIsOpen(false);
  };

  const handleClickOutside = event => {
    if (
      listRef.current.contains(event.target) ||
      activatorRef.current.contains(event.target)
    ) {
      return;
    }
    setIsOpen(false);
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    // clean up on unmount
    return function cleanup() {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  if (userProfile) {
    const userNameInitial = userProfile.name.slice(0, 1).toUpperCase();
    return (
      <UserContainer className={className}>
        <UserThumbnail
          ref={activatorRef}
          onClick={handleClick}
          aria-haspopup="true"
          aria-controls="user-actions-dropdown"
        >
          {userNameInitial}
        </UserThumbnail>
        <DropdownContainer
          ref={listRef}
          role="list"
          tabIndex="-1"
          id="user-actions-dropdown"
          className={isOpen ? 'active' : null}
        >
          <SignOut role="listitem" onClick={handleSignOut}>
            Sign out
          </SignOut>
        </DropdownContainer>
      </UserContainer>
    );
  } else return <></>;
};

export default UserAndActions;
